import {environment} from '@environments/environment';
import {StringUtil} from '@shared/util/string.util';

export class RouteGenerator {

  public static abs(path: string, params: {[name: string]: string;} = {}): string {
    return  '/' + this.resolve(path, params);
  }

  public static uiUrl(path: string, params: {[name: string]: string;} = {}): string {
    return environment.baseUrl + this.abs(path, params);
  }

  private static resolve(path: string, params: {[name: string]: string;} = {}): string {
    return StringUtil.mergeParams(path, params)!;
  }

}
